import { render } from "./Securitysection.vue?vue&type=template&id=4d0bd08c&scoped=true"
const script = {}

import "./Securitysection.vue?vue&type=style&index=0&id=4d0bd08c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0bd08c"]])

export default __exports__